export default class Module {
  constructor({
    id,
    name,
    description,
    thumbnail,
    modelUrl,
    totalSteps,
    totalQuizQuestions,
    createdAt,
    updatedAt,
    tags,
    version,
  }) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.thumbnail = thumbnail;
    this.modelUrl = modelUrl;
    this.totalSteps = totalSteps || 0;
    this.totalQuizQuestions = totalQuizQuestions || 0;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.tags = tags || [];
    this.version = version || 1;
  }
}
